import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const sitesSlice = createCrudSlice({
  name: 'sites',
})

export const SitesActions = sitesSlice.actions

export const SitesSelectors = { 
    ...createCrudSelectors({ name: 'sites' }), 

     // Selector personalizado para obtener el currentSite
    getCurrent: (state) => state.sites.currentSite
}

export default sitesSlice.reducer